import ApiClient from './ApiClient'
import { TilesInfo } from '../types/Entities/TilesInfoType';

const getRiskWOTilesData = async (apiClient: ApiClient) => {
    return apiClient
      .get<Array<TilesInfo>>(`RiskWOTiles/getriskwotilescount`)
      .catch(error => { throw error });
  }

const TilesInfoApi = {
  getRiskWOTilesData
  }
  export default TilesInfoApi